"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = Item;
exports.PillItem = PillItem;
exports.ClearAllPillItem = ClearAllPillItem;
exports.SinglePillItem = SinglePillItem;
exports.getShowText = getShowText;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _AutoEllipsis = _interopRequireDefault(require("./AutoEllipsis"));

function Item(props) {
  var onClick = props.onClick,
      className = props.className,
      children = props.children,
      style = props.style,
      color = props.color,
      rest = (0, _objectWithoutProperties2["default"])(props, ["onClick", "className", "children", "style", "color"]);
  var colorNode = (0, _react.useMemo)(function () {
    return (0, _isNil["default"])(color) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-1 h-8 mr-4",
      style: {
        backgroundColor: color
      }
    });
  }, [color]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    style: style,
    className: (0, _classnames["default"])(className, 'w-full flex items-center font-semibold jutify-between pr-4 py-3 hover:bg-secondary cursor-pointer select-none', {
      'pl-4': (0, _isNil["default"])(color)
    }),
    onClick: onClick
  }, rest), colorNode, children);
}

function PillItem(props) {
  var onClick = props.onClick,
      text = props.text,
      active = props.active,
      className = props.className,
      leftIcon = props.leftIcon,
      color = props.color,
      style = props.style,
      rest = (0, _objectWithoutProperties2["default"])(props, ["onClick", "text", "active", "className", "leftIcon", "color", "style"]);
  return /*#__PURE__*/_react["default"].createElement(Item, (0, _extends2["default"])({}, rest, {
    style: style,
    onClick: onClick,
    className: className,
    color: color
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex items-center min-w-0 text-left"
  }, leftIcon, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-4 truncate"
  }, text)), active && /*#__PURE__*/_react["default"].createElement(_Done["default"], {
    className: "text-primary"
  }));
}

function ClearAllPillItem(props) {
  var onClick = props.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#F7F7F7'
    },
    onClick: onClick,
    className: "m-1 ml-0 px-2 h-8 inline-flex !dark:bg-card items-center cursor-pointer rounded-full"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    style: {
      fontSize: 16
    }
  }));
}

function SinglePillItem(props) {
  var onClick = props.onClick,
      active = props.active,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    style: active ? {
      color: '#ffffff',
      backgroundColor: '#136AEE'
    } : {
      backgroundColor: '#F7F7F7'
    },
    className: (0, _classnames["default"])('m-1 pl-4 pr-4 h-8 text-sm inline-flex flex-no-wrap items-center cursor-pointer rounded-full', {
      '!dark:bg-card text-medium': !active
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-xs truncate"
  }, children));
}

function DisablePill(props) {
  var defalutText = props.defalutText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#F7F7F7'
    },
    className: (0, _classnames["default"])('m-1 pl-4 !dark:bg-card text-medium pr-2 opacity-30 h-8 text-sm inline-flex flex-no-wrap items-center rounded-full')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-xs"
  }, defalutText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-3 flex"
  }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)));
}

function Pill(props) {
  var defalutText = props.defalutText,
      showText = props.showText,
      isActive = props.isActive,
      children = props.children,
      customLeft = props.customLeft,
      _onClick = props.onClick,
      onClose = props.onClose,
      _props$disable = props.disable,
      disable = _props$disable === void 0 ? false : _props$disable;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = (0, _react.useRef)();

  var handleOnToggle = function handleOnToggle() {
    setOpen(!open);
  };

  var customLeftNode = (0, _react.useMemo)(function () {
    return !customLeft ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "ml-3 flex"
    }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)) : /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(e) {
        e.preventDefault();
        handleOnToggle();
      },
      className: (0, _classnames["default"])('divider w-8 h-8 flex ml-2 items-center rounded-r-full', {
        'hover:bg-primary-active dark:hover:bg-primary': isActive,
        'hover:bg-lightrey dark:hover:bg-card': !isActive
      })
    }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
      className: "border-l-1 border-opacity-15 hover:border-transparent"
    }));
  }, [customLeft, isActive, open]);

  if (disable) {
    return /*#__PURE__*/_react["default"].createElement(DisablePill, {
      defalutText: defalutText
    });
  }

  var onCloseChange = function onCloseChange() {
    handleOnToggle();

    if (onClose) {
      onClose();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: anchorRef,
    onClick: !customLeft && handleOnToggle,
    style: isActive ? {
      color: '#ffffff',
      backgroundColor: '#136AEE'
    } : {
      backgroundColor: '#F7F7F7'
    },
    className: (0, _classnames["default"])('m-1 first:ml-0 pl-4 h-8 relative text-sm inline-flex flex-no-wrap items-center cursor-pointer rounded-full', {
      '!dark:bg-card text-medium': !isActive,
      'pr-2': !customLeft,
      'opacity-30': disable
    })
  }, /*#__PURE__*/_react["default"].createElement(_AutoEllipsis["default"], {
    className: "max-w-xs truncate",
    text: showText || defalutText,
    onClick: function onClick(e) {
      e.preventDefault();

      if (_onClick) {
        _onClick();
      }
    }
  }), customLeftNode), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    style: {
      marginTop: '5px'
    },
    elevation: 6,
    onClose: onCloseChange,
    anchorEl: anchorRef.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, typeof children === 'function' ? children({
    handleOnToggle: handleOnToggle
  }) : children));
}

function getShowText(arr, key, options) {
  var defalutText = options.defalutText,
      text = options.text;
  if (!arr.length) return defalutText;
  var value = (0, _get["default"])(arr[0], key, text);
  return arr.length > 1 ? "".concat(value, " + ").concat(arr.length - 1) : value;
}

var _default = Pill;
exports["default"] = _default;
//# sourceMappingURL=index.js.map